<template>
  <div class="questionnaire-content-list">
    <div
      v-for="(item, idx) in list"
      :key="item.id"
      class="questionnaire-content-list__item"
    >
      <p class="questionnaire-content-list__item-name">
        <span v-if="!item.hidden">{{ idx + 1 }}.</span>
        <span v-html="item.name" />
      </p>
      <div
        v-if="item.buttonList"
        class="questionnaire-content-list__button-list-wrap"
      >
        <div class="questionnaire-content-list__button-list">
          <UiButton
            v-for="button in item.buttonList"
            :key="button.id"
            class="questionnaire-content-list__button -gray-"
            target="_blank"
            :href="button.href"
          >
            <p class="questionnaire-content-list__button-field">
              <Icon
                class="questionnaire-content-list__button-icon"
                :icon="button.icon"
              /><span>{{ button.name }}</span>
            </p>
          </UiButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {}
  }
};
</script>
